import React from 'react';
import '../styles/PromotionPopup.css';

const STANDARD_PROMOTION_OPTIONS = [
  { key: 'queen', label: 'Queen', symbol: { white: '♕', black: '♛' } },
  { key: 'rook', label: 'Rook', symbol: { white: '♖', black: '♜' } },
  { key: 'bishop', label: 'Bishop', symbol: { white: '♗', black: '♝' } },
  { key: 'knight', label: 'Knight', symbol: { white: '♘', black: '♞' } },
];

const DUKE_OPTION = {
  key: 'duke',
  label: 'Duke',
  // Duke uses custom image, so we'll use a placeholder symbol
  symbol: { white: '🛡', black: '🛡' }
};

const PromotionPopup = ({ side, onChoose, onClose, variant }) => {
  // For Pawn's Wild variant, include Duke as an option
  const options = variant === 'pawns_wild' 
    ? [...STANDARD_PROMOTION_OPTIONS, DUKE_OPTION]
    : STANDARD_PROMOTION_OPTIONS;

  return (
    <div className="promotion-popup-overlay" onClick={onClose}>
      <div className="promotion-popup" onClick={(e) => e.stopPropagation()}>
        <h3>Choose Promotion</h3>
        <div className="promotion-choices">
          {options.map(opt => (
            <button
              key={opt.key}
              className="promotion-choice"
              onClick={() => onChoose(opt.key)}
              data-testid={`promote-${opt.key}`}
            >
              <span className="promotion-piece">{opt.symbol[side]}</span>
              <span className="promotion-label">{opt.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromotionPopup;
